<template>
    <div class="padding10" v-wechat-title="title">
        <cus-form ref="form-saveas" :data="mdata" width="95%" class="table-h500" :columns="columnList" @confirm="SaveAs"></cus-form>
        <CloseButton ref="close-btn" type="confirm" @confirm="confirm" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DesktopRecordTemplateSaveAs`,
    props: {
        visible: { type: Boolean, default: () => false }
        // data:{type:Object}
    },
    data() {
        return {
            title: `用药模板另存为`,
            decimalPlaces: 3,
            surgeryId: this.$route.query.surgery_id,
            recordType: this.$route.query.record_type,
            isMerge: this.$route.query.isMerge,
            token: this.$route.query.token,
            key_event_config: [],
            dic_event_config: [],
            InfusionChannel: [],
            group_names: [],
            key_events: [],
            permissions: [],
            region_type: this.$root.ApplyTemplateDefaultRegionType,
            mdata: {},
            msg: `closeWindow`,
            dic_ward_id: undefined,
            onlySimpleWard: this.$root.OnlySimpleWard,
            surgeryInfo: null
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.loadgroup_name()
        this.loadDecimalPlaces()
        this.getlocalIp()
        this.init()
        this.loadPermissions()
        this.loadKeyEventConfig()
        this.loadDicEventConfig()
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`ADD_CURRENTUSER`)
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
        this.$store.dispatch(`ADD_HOSPITAL_WARD`)
        this.$store.dispatch(`ADD_OPERATION_WARD`)
        this.$store.dispatch(`ADD_RECOVERY_WARD`)

        this.loadInfusionChannel()
    },
    computed: {
        ...mapGetters([`ward_auth`, `hospital_ward_all`, `operation_ward_all`, `recovery_ward_all`, `currentUser`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `screenHeight`]),
        // add by xiaorui ACIS-22558
        // 日期：2021-08-16,
        // 功能：当前用户有区域按钮权限，才显示区域 按钮
        wardOptions() {
            let wards = null
            // ACIS-26427 麻烦啊，当 手术申请 source_hospital_ward_id 不为空,需要根据 来源院区过滤 手术区/复苏区
            if (this.surgeryInfo && this.surgeryInfo.source_hospital_ward_id) {
                wards = _.filter(this.ward_auth, ward => ward.groupId == this.surgeryInfo.source_hospital_ward_id)
            } else {
                wards = _.cloneDeep(this.ward_auth)
                // 是否开启单院区过滤
                if (!this.surgeryId && this.onlySimpleWard == `1`) {
                    // 从科室菜单-用药模版来的且 开启单院区过滤,根据右上角单院区来过滤
                    wards = _.filter(wards, ward => ward.groupId == this.active_ward.groupId)
                }
            }
            let r = []
            if (this.recordType == 2) {
                r = _.filter(wards, (d) => {
                    return _.startsWith(d.value, `rw_`) == true
                })
            } else {
                r = _.filter(wards, (d) => {
                    return _.startsWith(d.value, `ow_`) == true
                })
            }
            console.log(`***********************`)
            console.log(r)
            return r
        },
        hasRegionTypePermission() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            if (_.find(this.permissions, { no: `RecordTemplate:RegionType` }) != undefined) {
                r.push({ label: `区域`, value: 2 })
                this.region_type = this.$root.ApplyTemplateDefaultRegionType
            }
            return r
        },
        columnList() {
            return [
                {
                    type: `select`,
                    prop: `group_name`,
                    label: `分组名称`,
                    isListable: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 5,
                    config: {
                        allowCreate: true
                    },
                    options: this.group_names,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `模板名称`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 5,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 5,
                    options: this.hasRegionTypePermission,
                    default: this.region_type
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    // width: "180",
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 5,
                    options: this.wardOptions,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `dic_event_id`,
                    label: `偏移基准`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 4,
                    options: this.key_event_config,
                    change: (that, { row }) => {
                        let itm = _.find(this.key_events, { dic_event_id: row.dic_event_id })
                        if (itm) {
                            let tmplates = _.map(row.record_templates, d => {
                                let r = { ...d }
                                r.time_offset = parseInt((this.$moment(d.occur_time).valueOf() - this.$moment(itm.occur_time).valueOf()) / 60000)
                                if (r.item_type > -1 && r.is_continue && r.occur_time_end) {
                                    r.time_offset_end = parseInt((this.$moment(d.occur_time_end).valueOf() - this.$moment(itm.occur_time).valueOf()) / 60000)
                                }
                                return r
                            })
                            this.$set(row, `record_templates`, tmplates)
                        }
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `table`,
                    prop: `record_templates`,
                    label: `项目`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `排序`,
                            isKey: true
                        },
                        {
                            type: `select`,
                            prop: `item_type`,
                            label: `项目类型`,
                            width: `100`,
                            isListable: true,
                            readonly: false,
                            options: [{ label: `事件`, value: -1 }].concat(this[`drug/drug_type`]),
                            change: (that, { row, area }) => {
                                this.$delete(row, `item`)
                            }
                        },
                        {
                            type: `remoteselect`,
                            prop: `item`,
                            label: `项目名称`,
                            width: `260`,
                            isListable: true,
                            readonly: false,
                            options: (that, { row }) => {
                                return q => {
                                    if (row.item_type == -1) {
                                        return this.dic_event_config
                                    } else if (row.item_type) {
                                        q.drugType = row.item_type
                                        return this.myaxios.get(`/api/AcisSystem/Drug/SearchFidlerHospitalWard?surgeryid=${this.surgeryId}`, q)
                                    } else {
                                        return []
                                    }
                                }
                            },
                            change: (that, { row, area }) => {
                                if (row.item_type > -1) {
                                    let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.item.value}`)
                                    req.then(data => {
                                        //   this.$set(row,'spec',data&&data.spec)
                                        this.$set(row, `unit`, data && data.drug_unit)
                                        this.$set(row, `speed_unit`, data && data.speed_unit)
                                        this.$set(row, `speed_dose`, data && data.speed_dose)
                                        this.$set(row, `dose`, data && data.dose)
                                        this.$set(row, `add_drug_way`, data && data.add_drug_way)
                                        this.$set(row, `is_continue`, data && data.is_continue)
                                        this.$set(row, `is_speed`, data && data.is_speed)
                                        this.$set(row, `enable_concentration`, data && data.enable_concentration)
                                        if (data.enable_concentration) {
                                            this.$set(row, `concentration`, data && data.concentration || 0)
                                            this.$set(row, `concentration_unit`, data && data.concentration_unit)
                                        } else {
                                            this.$set(row, `concentration`, 0)
                                        }
                                    })
                                } else {
                                    this.$set(row, `unit`, undefined)
                                    this.$set(row, `speed_unit`, undefined)
                                    this.$set(row, `speed_dose`, undefined)
                                    this.$set(row, `dose`, undefined)
                                    this.$set(row, `add_drug_way`, undefined)
                                    this.$set(row, `is_continue`, undefined)
                                    this.$set(row, `is_speed`, undefined)
                                    this.$set(row, `concentration`, undefined)
                                    this.$set(row, `concentration_unit`, undefined)
                                    this.$set(row, `enable_concentration`, false)
                                }
                            }
                        },
                        {
                            type: `integer1`,
                            prop: `time_offset`,
                            label: `开始时间(分钟)`,
                            width: `70`,
                            isListable: true,
                            readonly: false,
                            default: 1
                        },
                        {
                            type: `integer1`,
                            prop: `time_offset_end`,
                            label: `结束时间(分钟)`,
                            width: `70`,
                            isListable: true,
                            readonly: (that, { row }) => {
                                return !row.is_continue || row.item_type == -1
                            },
                            default: 1
                        },
                        {
                            type: `float`,
                            prop: `dose`,
                            label: `剂量`,
                            width: `100`,
                            isListable: true,
                            readonly: false,
                            default: 0
                        },
                        {
                            type: `select`,
                            prop: `unit`,
                            label: `单位`,
                            isListable: true,
                            width: `55`,
                            readonly: false,
                            options: _.filter(this[`drug/drug_unit`], { isconcentration: false, isspeed: false, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            })
                        },
                        {
                            type: `bool`,
                            prop: `is_continue`,
                            label: `连续`,
                            isListable: true,
                            width: `45`,
                            readonly: false,
                            options: `enum_bool`,
                            change: (that, { row, area }) => {
                                if (!row.is_continue) {
                                    this.$set(row, `speed_unit`, null)
                                    this.$set(row, `speed_dose`, null)
                                    this.$set(row, `is_speed`, false)
                                }
                            }
                        },
                        {
                            type: `bool`,
                            prop: `is_speed`,
                            label: `流量`,
                            isListable: true,
                            width: `45`,
                            readonly: false,
                            options: `enum_bool`,
                            change: (that, { row, area }) => {
                                if (!row.is_speed) {
                                    this.$set(row, `speed_unit`, null)
                                    this.$set(row, `speed_dose`, null)
                                } else {
                                    this.$set(row, `speed_dose`, 0)
                                    this.$set(row, `is_continue`, true)
                                }
                            }
                        },

                        {
                            type: `float`,
                            prop: `speed_dose`,
                            label: `流速`,
                            width: `50`,
                            isListable: true,
                            readonly: (that, { row }) => {
                                return !row.is_speed
                            },
                            default: 0
                        },
                        {
                            type: `select`,
                            prop: `speed_unit`,
                            label: `流速单位`,
                            isListable: true,
                            width: `80`,
                            readonly: (that, { row }) => {
                                return !row.is_speed
                            },
                            options: _.filter(this[`drug/drug_unit`], { isspeed: true, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            })
                        },
                        {
                            type: `float`,
                            prop: `concentration`,
                            label: `浓度`,
                            isListable: true,
                            decimal_places: this.decimalPlaces,
                            width: `80`,
                            readonly: (that, { row }) => {
                                return !row.enable_concentration
                            }
                        },
                        {
                            type: `select`,
                            prop: `concentration_unit`,
                            label: `浓度单位`,
                            isListable: true,
                            width: `80`,
                            readonly: (that, { row }) => {
                                return !row.enable_concentration
                            },
                            options: _.filter(this[`drug/drug_unit`], { isconcentration: true, disabled: false }).map(d => {
                                return {
                                    value: d.label,
                                    label: d.label
                                }
                            })
                        },
                        {
                            type: `select`,
                            prop: `add_drug_way`,
                            label: `途径`,
                            isListable: true,
                            width: `120`,
                            readonly: false,
                            options: _.map(this[`drug/drug_way`], d => {
                                return {
                                    value: d.label,
                                    label: d.label,
                                    jianpin: d.jianpin
                                }
                            })
                        },

                        {
                            type: `select`,
                            prop: `dic_infusion_channel_id`,
                            label: `用药通道`,
                            width: `120`,
                            isListable: true,
                            readonly: false,
                            options: this.InfusionChannel
                            // default: this.InfusionChannel&&this.InfusionChannel[0]&&this.InfusionChannel[0].value
                        },
                        {
                            type: `string`,
                            prop: `remark`,
                            label: `备注`,
                            isListable: true,
                            readonly: false
                        }
                    ],
                    colspan: 24,
                    default: []
                }
            ]
        }
    },
    methods: {
        loadgroup_name() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`api/AcisSystem/RecordTemplate/GetGroupNames`)
                req.then(data => {
                    if (data) {
                        this.group_names = data
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadDecimalPlaces() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ConcentrationDecimalPoint`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.decimalPlaces = parseInt(data.value)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        getlocalIp() {
            return new Promise(resolve => {
                let req = this.myaxios.post(`/api/Anonymous/InternalServer/GetMyIp`)
                req.then(data1 => {
                    let req1 = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${data1}`)
                    req1.then((data) => {
                        if (data) {
                            let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${data.dic_operating_room_id || 0}`)
                            req1.then(d => {
                                data = {
                                    dic_recovery_ward_id: d && d.dic_operating_ward_id || data.dic_recovery_ward_id,
                                    dic_operating_room_id: data.dic_operating_room_id,
                                    token: data.token,
                                    id: data.id,
                                    work_station_type: data.dic_operating_room_id ? 1 : 2
                                }
                                this.dic_ward_ids = data.work_station_type == 1 ? `ow_${data.dic_recovery_ward_id}` : `rw_${data.dic_recovery_ward_id}`
                            }).catch(e => {
                                console.log(e)
                            })
                        }
                    })
                    resolve(data1)
                })
            })
        },
        loadKeyEventConfig() {
            return new Promise((resolve, reject) => {
                let recodetype = this.recordType
                if (this.isMerge == `True`) {
                    recodetype = 2
                }
                let req = this.myaxios.get(`/api/AcisSystem/KeyEventConfig/Configs`, { surgeryInfoId: this.surgeryId, recordType: recodetype })
                req.then(data => {
                    this.key_event_config =
                        data &&
                        _.orderBy(
                            _.filter(data, d => {
                                return d.evt && !d.evt.is_deleted
                            }),
                            `display_order`
                        ).map(d => {
                            return {
                                value: d.evt.id,
                                label: d.evt.name
                            }
                        })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadDicEventConfig() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Event/SearchEvent`)
                req.then(data => {
                    this.dic_event_config =
                        data &&
                        data.map(d => {
                            return {
                                value: d.value,
                                label: d.label
                            }
                        })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
                console.log(e)
            })
        },
        loadInfusionChannel() {
            let req = this.myaxios.get(`/api/AcisSystem/InfusionChannel/Get`)
            req.then(data => {
                this.InfusionChannel =
                    data &&
                    data.map(d => {
                        return {
                            value: d.id,
                            label: d.name
                        }
                    })
            }).catch(e => {
                console.log(e)
            })
        },
        init() {
            let recodetype = this.recordType
            if (this.isMerge == `True`) {
                recodetype = 2
            }
            let req1 = this.myaxios.get(`/api/Intraoperative/Anaesthesia/GetUseDrug?surgeryInfoId=${this.surgeryId}&recordType=${this.recordType}`)
            let req2 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/OccuredEvents?surgeryInfoId=${this.surgeryId}&recordType=${this.recordType}`)
            let req3 = this.myaxios.get(`/api/AcisSystem/RecordTemplate/OccuredEvents?surgeryInfoId=${this.surgeryId}&recordType=${recodetype}`)
            let req4 = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)

            this.myaxios.all(req1, req2, req3, req4).then(([drugs, events, events2, surgery]) => {
                console.log(drugs)
                this.surgeryInfo = surgery
                this.key_events = _.filter(events2, `is_key_event`)
                let dd = {}
                dd.record_templates =
                    _.filter(events, d => {
                        return !d.is_key_event
                    }).map(d => {
                        return {
                            occur_time: d.occur_time,
                            item_type: -1,
                            item: { value: d.dic_event_id, label: d.event_name },
                            time_offset: d.time_offset,
                            specify_date: d.specify_date,
                            remark: d.remark
                        }
                    }) || []
                _.forEach(drugs, ds => {
                    let r = ds.usage_details.map(d => {
                        return {
                            occur_time: d.begin_time,
                            occur_time_end: d.end_time,
                            item_type: ds.dic_drug_type_id,
                            item: { value: ds.dic_drug_id, label: ds.dic_drug_name, jianpin: ds.drug.abbr },
                            dose: d.dose,
                            speed_dose: !d.is_continue ? null : (d.is_speed ? d.speed_dose : null),
                            speed_unit: !d.is_continue ? null : (d.is_speed ? d.speed_unit : null),
                            unit: d.unit,
                            concentration_unit: d.concentration_unit,
                            concentration: d.concentration,
                            enable_concentration: d.enable_concentration,
                            add_drug_way: d.add_drug_way,
                            is_continue: d.is_continue,
                            is_speed: !d.is_continue ? false : d.is_speed,
                            specify_date: null,
                            dic_infusion_channel_id: d.dic_infusion_channel_id,
                            remark: d.remark
                        }
                    })

                    dd.record_templates.push(...r)
                })

                this.mdata = dd
            })
        },
        // eslint-disable-next-line camelcase
        saveOne({ group_name, record_templates, name, dic_event_id, region_type, dic_ward_ids }) {
            // eslint-disable-next-line camelcase
            if (region_type == 2 && (!dic_ward_ids || dic_ward_ids.length == 0)) {
                this.$message.warning(`请选择可用区域`)
                return
            }
            let data = { group_name, name, dic_event_id }
            data.enum_record_type = this.recordType
            let vld = _.findIndex(record_templates, d => {
                return d.item == undefined || d.item_type.length == 0
            })
            if (vld > -1) {
                this.$message.warning(`项目或者项目类型不能为空`)
                return
            }

            data.drug_record_templates = _.filter(record_templates, d => d.item_type > -1).map(d => {
                d.dic_drug_type_id = d.item_type
                d.dic_drug_id = d.item.value
                d.remark = d.remark
                d.concentration_unit = d.concentration_unit
                return d
            })

            vld = _.findIndex(data.drug_record_templates, d => {
                return ((d.time_offset == undefined || d.time_offset.length == 0) && d.specify_date == null)
            })
            if (vld > -1) {
                this.$message.warning(`开始时间或者指定时间不能为空`)
                return
            }
            data.event_record_templates = _.filter(record_templates, d => d.item_type == -1).map((d, index) => {
                return {
                    dic_event_id: d.item.value,
                    display_order: index + 1,
                    remark: d.remark,
                    specify_date: d.specify_date,
                    time_offset: d.time_offset
                }
            })
            // eslint-disable-next-line camelcase
            data.regions =
                // eslint-disable-next-line camelcase
                region_type == 1
                    ? [{ owner: this.currentUser.username }]
                    : dic_ward_ids.map(d => {
                        return {
                            dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    })
            data.enum_record_type = this.recordType
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/AcisSystem/RecordTemplate/Post`, data)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        SaveAs(row) {
            // console.log(row)
            this.saveOne(row).then(data => {
                this.$refs[`close-btn`].close()
            })
        },
        confirm($that) {
            this.$refs[`form-saveas`].confirm()
        }
    }
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/DesktopRecordTemplateSaveAs.vue